import * as React from "react";

function SvgIcArrowRight(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.293 7.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L16.586 13H5a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcArrowRight;
